import { event } from '@uhg-abyss/web/tools/event';
import { logger } from '@uhg-abyss/web/tools/logger';
import { config } from '@uhg-abyss/web/tools/config';
import {
  addElasticApmLabels,
  validateAndInitializeElasticApm,
} from './helpers';

export const elasticApmAnalytics = (options) => {
  if (options.enabled !== false) {
    const { hostname } = window.location;
    const eapmEnv = config('EAPM_ENV');
    const serverUrl =
      hostname === 'secure.uhcprovider.com'
        ? 'https://eapm-gw.uhc.com'
        : 'https://eapm-gw-nonprod.uhc.com';

    const initParams = {
      serverUrl,
      environment: `${options.name || 'sde-core'}:${eapmEnv}`,
      serviceName: options?.serviceName || config('ELASTIC_APM_SERVICE_NAME'),
    };

    validateAndInitializeElasticApm(initParams);

    return {
      id: options.id,
      events: options.events,
      metadata: options.metadata,
      trigger: (tag) => {
        if (options.logging) {
          logger.warn(`Elastic APM: ${tag.event}`, tag.data);
        }

        event.waitFor(
          () => {
            return validateAndInitializeElasticApm(initParams);
          },
          () => {
            addElasticApmLabels(tag);
          }
        );
      },
    };
  }
  return {};
};
